import { EditLessonComponent } from './pages/courses/edit-lesson/edit-lesson.component';
import { ServeQuizComponent } from './pages/courses/serve-quiz/serve-quiz.component';
import { EditQuizComponent } from './pages/courses/edit-quiz/edit-quiz.component';
import { EditPdfComponent } from './pages/courses/edit-pdf/edit-pdf.component';
import { EditCourseComponent } from './pages/courses/edit-course/edit-course.component';
import { EditVideoComponent } from './pages/courses/edit-video/edit-video.component';
import { AddPdfComponent } from './pages/courses/add-pdf/add-pdf.component';
import { AddQuizComponent } from './pages/courses/add-quiz/add-quiz.component';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { SharedUiComponentsModule } from '../../../../libs/shared/ui/components/src/lib/shared-ui-components.module';
import { StaffComponent } from './pages/staff/staff.component';
import { StaffDetailsComponent } from './pages/staff/staff-details/staff-details.component';
import { NavbarComponent } from './component/navbar/navbar.component';
import { AssignCourseComponent } from './pages/assign-course/assign-course.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatNativeDateModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ChooseDateComponent } from './pages/assign-course/choose-date/choose-date.component';
import { ConfirmationComponent } from './pages/assign-course/confirmation/confirmation.component';
import { SelectCourseComponent } from './pages/assign-course/select-course/select-course.component';
import { LearningPathsComponent } from './pages/learning-paths/learning-paths.component';
import { CategoriesComponent } from './pages/categories/categories.component';
import { MentorshipComponent } from './pages/mentorship/mentorship.component';
import { CoursesComponent } from './pages/courses/courses.component';
import { SettingComponent } from './pages/setting/setting.component';
import { sharedNavbarModule } from './component/sharedNavbar.module';
import { ViewLearningPathComponent } from './pages/learning-paths/view-learning-path/view-learning-path.component';
import { EditLearningPathComponent } from './pages/learning-paths/edit-learning-path/edit-learning-path.component';
import { CreateNewLearningPathComponent } from './pages/learning-paths/create-new-learning-path/create-new-learning-path.component';
import { ManageCategoryComponent } from './pages/categories/manage-category/manage-category.component';
import { CourseDetailsComponent } from './pages/courses/course-details/course-details.component';
import { CreateCourseComponent } from './pages/courses/create-course/create-course.component';
import { AddLessonComponent } from './pages/courses/add-lesson/add-lesson.component';
import { SelectLessonTypeComponent } from './pages/courses/select-lesson-type/select-lesson-type.component';
import { UploadCertificateComponent } from './pages/courses/upload-certificate/upload-certificate.component';
import { SettingDepartmentalComponent } from './pages/setting/setting-departmental/setting-departmental.component';
import { SettingPrivilegesComponent } from './pages/setting/setting-privileges/setting-privileges.component';
import { SettingProfileComponent } from './pages/setting/setting-profile/setting-profile.component';
import { SettingStructureComponent } from './pages/setting/setting-structure/setting-structure.component';
import { ShareModule } from '@iq-central-front-end/share';
import { ToastrService, ToastrModule } from 'ngx-toastr';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HrInterceptorService } from './interceptors/hr-interceptor.service';
import { JwtHelperService, JwtModule } from '@auth0/angular-jwt';
import { WelcomeComponent } from './pages/welcome/welcome.component';
import { AuthGuardService } from './_guards/auth-guard.service';
import { AddVideoComponent } from './pages/courses/add-video/add-video.component';
import { ViewMenteesComponent } from './pages/staff/view-mentees/view-mentees.component';
import { NotificationComponent } from './pages/notification/notification.component';
import { MyLearningComponent } from './pages/my-learning/my-learning.component';
import { AlertComponent } from './component/alert/alert.component';
import { RbacAllowDirective } from './_directives/rbac-allow.directive';
import { StaffChatsComponent } from './pages/Staff-chats/staff-chats.component';
import { ChatComponent } from './pages/chat/chat.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { FILTER_CONFIG } from 'libs/shared/ui/components/src/lib/shared-services/shared.service';
import { environment } from '../environments/environment';

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuardService],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        component: DashboardComponent,
      },
      {
        path: 'staff',
        loadChildren: () =>
          import('./pages/staff/staff.module').then(
            (module) => module.StaffModule
          ),
      },
      {
        path: 'assignCourse',
        loadChildren: () =>
          import('./pages/assign-course/assign-course.module').then(
            (module) => module.AssignCourseModule
          ),
      },
      {
        path: 'learningPath',
        loadChildren: () =>
          import('./pages/learning-paths/learning-paths.module').then(
            (module) => module.LearningPathsModule
          ),
      },
      {
        path: 'mentorship',
        loadChildren: () =>
          import('./pages/mentorship/mentorship.module').then(
            (module) => module.MentorshipModule
          ),
      },
      {
        path: 'setting',
        loadChildren: () =>
          import('./pages/setting/setting.module').then(
            (module) => module.SettingModule
          ),
      },
      {
        path: 'courses',
        loadChildren: () =>
          import('./pages/courses/courses.module').then(
            (module) => module.CoursesModule
          ),
      },
      {
        path: 'categories',
        loadChildren: () =>
          import('./pages/categories/categories.module').then(
            (module) => module.CategoriesModule
          ),
      },
      {
        path: 'learning',
        loadChildren: () =>
          import('./pages/my-learning/my-learning.module').then(
            (module) => module.MyLearningModule
          ),
      },
      {
        path: 'messages',
        component: StaffChatsComponent,
      },
    ],
  },
  {
    path: 'welcome/:id/:guid',
    component: WelcomeComponent,
  },
];
@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    StaffComponent,
    StaffDetailsComponent,
    AssignCourseComponent,
    NotificationComponent,
    ChooseDateComponent,
    ConfirmationComponent,
    MyLearningComponent,
    ServeQuizComponent,
    SelectCourseComponent,
    ViewMenteesComponent,
    LearningPathsComponent,
    ViewLearningPathComponent,
    EditLearningPathComponent,
    CreateNewLearningPathComponent,
    ManageCategoryComponent,
    CategoriesComponent,
    NavbarComponent,
    MentorshipComponent,
    CoursesComponent,
    CourseDetailsComponent,
    CreateCourseComponent,
    AddLessonComponent,
    SelectLessonTypeComponent,
    AddVideoComponent,
    AddQuizComponent,
    AddPdfComponent,
    EditVideoComponent,
    EditCourseComponent,
    EditLessonComponent,
    EditPdfComponent,
    EditQuizComponent,
    UploadCertificateComponent,
    SettingComponent,
    SettingDepartmentalComponent,
    AlertComponent,
    SettingPrivilegesComponent,
    RbacAllowDirective,
    SettingProfileComponent,
    SettingStructureComponent,
    StaffChatsComponent,
    ChatComponent,
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(routes, { initialNavigation: 'enabled' }),
    SharedUiComponentsModule,
    // sharedNavbarModule,
    NgApexchartsModule,
    MatFormFieldModule,
    MatSelectModule,
    BrowserAnimationsModule,
    MatDatepickerModule,
    MatInputModule,
    MatNativeDateModule,
    ShareModule,
    JwtModule.forRoot({
      config: {},
    }),
    NgxSkeletonLoaderModule,
  ],
  providers: [
    ToastrService,
    JwtHelperService,
    AuthGuardService,
    { provide: HTTP_INTERCEPTORS, useClass: HrInterceptorService, multi: true },
    { provide: FILTER_CONFIG, useValue: environment.filterConfig },
  ],
  exports: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
